import axios from "axios";

import dotenv from 'dotenv';

dotenv.config();

//const s = process.env.REACT_APP_API_HOST + ":" + process.env.REACT_APP_PORT_API + "/api/" ;
/* const s = process.env.REACT_APP_API_HOST; //https://tg-api-locator.tg41.uk/api/
const API_URL = s.replace(/'/g, "");

const API_IMAGE_WEB = process.env.REACT_APP_API_IMAGE_WEB
 */
const API_URL = process.env.REACT_APP_API;

export function api_test() {
  console.log('api test!!!', API_URL)

}

export function api_req_get_device_list( token ) {

  //console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'GET',
      url: API_URL + "/api/dev/get_device_list",
      //params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

}

export function api_req_get_projects_by_user( token, user_id ) {
  //console.log('Hello2', API_URL + `/api/front/projects_by_user?user_id=${user_id}` )
  //console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'GET',
      url: API_URL + `/api/front/projects_by_user?user_id=${user_id}`,
      //params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

}

export function api_req_get_project_desks_by_user_and_project_id( token, user_id, project_id ) {

  //console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'GET',
      url: API_URL + `/api/front/get_project_by_user_and_project_id?user_id=${user_id}&project_id=${project_id}`,
      //params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

}


export function api_req_get_sensorlist_by_desk_id_and_user_id( token, user_id, desk_id ) {
  //https://apiwifi.hb41.uk/api/front/get_sensorlist_by_desk_id_and_user_id?user_id=1&desk_id=3
  //console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'GET',
      url: API_URL + `/api/front/get_sensorlist_by_desk_id_and_user_id?user_id=${user_id}&desk_id=${desk_id}`,
      //params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

}


export function api_req_get_devlist_by_desk_id_and_user_id( token, user_id, desk_id ) {

  //console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'GET',
      url: API_URL + `/api/front/get_devlist_by_desk_id_and_user_id?user_id=${user_id}&desk_id=${desk_id}`,
      //params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

}

export function api_req_get_devlist_skeleton_by_desk_id_and_user_id( token, user_id, desk_id ) {

  //console.log(token)
  //console.log(API_URL + `/api/front_02_mobile/get_devlist_skeleton_by_desk_id_and_user_id?user_id=${user_id}&desk_id=${desk_id}`)
  const options = {
      method: 'GET',
      url: API_URL + `/api/front_02_mobile/get_devlist_skeleton_by_desk_id_and_user_id?user_id=${user_id}&desk_id=${desk_id}`,
      //params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

}

export function api_req_get_device_skeleton_by_dev_id_and_user_id( token, user_id, dev_id ) {

  //console.log(token)
  //console.log(API_URL + `/api/front_02_mobile/get_device_skeleton_by_dev_id_and_user_id??user_id=${user_id}&dev_id=${dev_id}`)
  const options = {
      method: 'GET',
      url: API_URL + `/api/front_02_mobile/get_device_skeleton_by_dev_id_and_user_id?user_id=${user_id}&dev_id=${dev_id}`,
      //params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

}

export function api_req_get_sensors_data_by_dev_id_and_user_id( token, user_id, dev_id ) {

  //console.log(token)
  //console.log(API_URL + `/api/front_02_mobile/get_sensors_data_by_dev_id_and_user_id?user_id=${user_id}&dev_id=${dev_id}`)
  //https://apiwifi.hb41.uk/api/front_02_mobile/get_sensors_data_by_dev_id_and_user_id?user_id=1&dev_id=3
  const options = {
      method: 'GET',
      url: API_URL + `/api/front_02_mobile/get_sensors_data_by_dev_id_and_user_id?user_id=${user_id}&dev_id=${dev_id}`,
      //params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

}

export function api_req_get_dev_color_code_by_dev_id( token, user_id, dev_id ) {

  //console.log(token)
  //console.log(API_URL + `/api/front_02_mobile/get_sensors_data_by_dev_id_and_user_id?user_id=${user_id}&dev_id=${dev_id}`)
  //https://apiwifi.hb41.uk/api/front_02_mobile/get_sensors_data_by_dev_id_and_user_id?user_id=1&dev_id=3
  const options = {
      method: 'GET',
      url: API_URL + `/api/front/get_dev_color_code_by_dev_id?user_id=${user_id}&dev_id=${dev_id}`,
      //params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

}


export function api_req_get_devinfo_by_dev_id_and_user_id( token, user_id, dev_id ) {

  //console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'GET',
      url: API_URL + `/api/front/get_devinfo_by_dev_id_and_user_id?user_id=${user_id}&dev_id=${dev_id}`,
      //params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

}
export function api_req_get_sensorlist_by_dev_id_and_user_id( token, user_id, dev_id ) {

  //console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'GET',
      url: API_URL + `/api/front/get_sensorlist_by_dev_id_and_user_id?user_id=${user_id}&dev_id=${dev_id}`,
      //params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

}

export function api_req_get_data_all_collections( token ) {

  //console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'GET',
      url: API_URL + "/api/front/data_all_collections",
      //params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

}

export function api_req_stats_restarting_all_devs_by_5days( token ) {

  //console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'GET',
      url: API_URL + "/api/front/stats_restarting_all_devs_by_5days",
      //params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

}

//device_list_by_user_role
export function api_req_device_list_by_user_role( token, actionData) {

  //console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'POST',
      url: API_URL + "/api/front/device_list_by_user_role",
      //params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      data: actionData
    };
 // console.log(options) 
  return axios.request(options) 

}

export function api_req_data_h_t_by_collection_id_x_days_back( token, actionData) {

  //console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'POST',
      url: API_URL + "/api/front/data_h_t_by_collection_id_x_days_back",
      //params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      data: actionData
    };
 // console.log(options) 
  return axios.request(options) 

}

export function api_req_info_and_sensors_data_of_dev_id( token, actionData) {

  //console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'POST',
      url: API_URL + "/api/front/data_userid_devid_actions_and_senors_list",
      //params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      data: actionData
    };
 // console.log(options) 
  return axios.request(options) 

}

export function api_req_data_userid_devid_actions_and_senors_list_by_date( token, actionData) {

  //console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'POST',
      url: API_URL + "/api/front/data_userid_devid_actions_and_senors_list_by_date",
      //params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      data: actionData
    };
 // console.log(options) 
  return axios.request(options) 

}

export function api_req_device_list_by_user_role_plus_dev_id( token, actionData) {

  //console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'POST',
      url: API_URL + "/api/front/device_list_by_user_role_plus_dev_id",
      //params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      data: actionData
    };
 // console.log(options) 
  return axios.request(options) 


}
export function api_req_insert_actions(token, actionData) {

  //console.log("axios test")
  //console.log(API_URL)
  const options = {
      method: 'POST',
      url: API_URL + "/api/front/insert_action",
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      data: actionData
    };
  //console.log(options) 
  return axios.request(options) 

}

export function api_req_rx_actions_by_dev_id(token, pData) {

  //console.log('Hello api_req_get_actions_by_dev_id!')
  //console.log("axios test")
  //console.log(API_URL)
  const options = {
      method: 'POST',
      url: API_URL + "/api/front/rx_actions_by_dev_id",
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      data: pData
    };
  //console.log(options) 
  return axios.request(options) 

}

export function api_req_rx_events_by_dev_id(token, pData) {

  //console.log('Hello api_req_rx_events_by_dev_id!')
  //console.log("axios test")
  //console.log(API_URL)
  const options = {
      method: 'POST',
      url: API_URL + "/api/front/rx_events_by_dev_id",
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      data: pData
    };
  //console.log(options) 
  return axios.request(options) 

}

export function api_req_rx_log_by_dev_id(token, pData) {

  //console.log('Hello api_req_rx_log_by_dev_id!')
  //console.log("axios test")
  //console.log(API_URL)
  const options = {
      method: 'POST',
      url: API_URL + "/api/front/rx_log_by_dev_id",
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      data: pData
    };
  //console.log(options) 
  return axios.request(options) 

}

export function api_req_rx_state_by_dev_id(token, pData) {

  //console.log('Hello api_req_rx_state_by_dev_id!')
  //console.log("axios test")
  //console.log(API_URL)
  const options = {
      method: 'POST',
      url: API_URL + "/api/front/rx_state_by_dev_id",
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      data: pData
    };
  //console.log(options) 
  return axios.request(options) 

}

//"/api/front/delete_action_by_id",
export function api_req_delete_action_by_id(token, pData) {

  //console.log('Hello api_req_delete_action_by_id!')
  //console.log("axios test")
  //console.log(API_URL)
  const options = {
      method: 'POST',
      url: API_URL + "/api/front/delete_action_by_id",
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      data: pData
    };
  //console.log(options) 
  return axios.request(options) 

}

export function api_req_rx_sensor_data_hourly_by_selectedDevId_sensorId(token, pData) {

  //console.log('Hello api_req_rx_sensor_data_by_selectedDevId_sensorId!')
  //console.log("axios test")
  //console.log(API_URL)
  const options = {
      method: 'POST',
      url: API_URL + "/api/front/data_for_graph_by_day_hourly_temperature_humidity",
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      data: pData
    };
  //console.log(options) 
  return axios.request(options) 

}

export function api_req_rx_sensor_data_30m_by_selectedDevId_sensorId(token, pData) {

  //console.log('Hello api_req_rx_sensor_data_by_selectedDevId_sensorId!')
  //console.log("axios test")
  //console.log(API_URL)
  const options = {
      method: 'POST',
      url: API_URL + "/api/front/data_for_graphby_day_30min_temperature_humidity",
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      data: pData
    };
  //console.log(options) 
  return axios.request(options) 

}

export function api_req_rx_sensor_data_daily_by_selectedDevId_sensorId(token, pData) {

  //console.log('Hello api_req_rx_sensor_data_by_selectedDevId_sensorId!')
  //console.log("axios test")
  //console.log(API_URL)
  const options = {
      method: 'POST',
      url: API_URL + "/api/front/data_for_graph_xdays_back_temperature_humidity",
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      data: pData
    };
  //console.log(options) 
  return axios.request(options) 

}

//2025-01-12
export function api_req_30min_data_by_date_devid_sensorid_fields(token, pData) {
//https://apiwifi.hb41.uk/api/front/req_30min_data_by_date_devid_sensorid_fields

  //console.log('Hello api_req_rx_sensor_data_by_selectedDevId_sensorId!')
  //console.log("axios test")
  //const {dev_id, sensor_id, date_i, fields} = req.body
  const options = {
      method: 'POST',
      url: API_URL + "/api/front/req_30min_data_by_date_devid_sensorid_fields",
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      data: pData
    };
  //console.log(options) 
  return axios.request(options) 

}

export function api_req_manager_graph_and_xlsx_data(token, pData) {
  //https://apiwifi.hb41.uk/api/front_02_mobile/manager_graph_data
    //console.log(pData)
    //console.log('Hello api_req_rx_sensor_data_by_selectedDevId_sensorId!')
    //console.log("axios test: ", '/api/front_02_mobile/manager_graph_data')
    //const {dev_id, sensor_id, date_i, fields} = req.body
    const options = {
        method: 'GET',
        url: API_URL + "/api/front_02_mobile/manager_graph_and_xlsx_data",
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token
        },
        params: pData
      };
    //console.log(options) 
    return axios.request(options) 
  
  }
//https://apiwifi.hb41.uk/api/front_02_mobile/manager_xlsx_link

  
//const aa ="ttt" process.env.REACT_APP_API_HOST + "

/* //Get al images by locatorId
export function api_req_thumbnails(locatorId) {

  //console.log(`${API_IMAGE_WEB}/get_all_images_by_id/${locatorId}`)
  return axios.get(`${API_IMAGE_WEB}/get_all_images_by_id/${locatorId}`)

}

export function api_req_delete_all_images_by_id(locatorId) {

  console.log(`${API_IMAGE_WEB}/delete_images/${locatorId}`)
  axios.delete(`${API_IMAGE_WEB}/delete_images/${locatorId}`)
  .then(
    (response) => {
      console.log(response.data)
    },
    (error) => {
      console.log(error.message)
    }

  )
} */

/* 
export function api_req_locid_info(locationId, chat_id, token) {


    //console.log("axios test")
    //console.log(API_URL)
    const options = {
        method: 'POST',
        url: API_URL + "tg_location_id_req_data",
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token
        },
        data: {"location_id": locationId, "chat_id": chat_id.toString()}
      };
    //console.log(options) 
    return axios.request(options) 

}

export function api_req_locid_delete(locationId, token) {

  console.log(locationId)
  console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'DELETE',
      url: API_URL + "tg_location_id_req_data_delete",
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      data: {location_id: locationId}
    };
 // console.log(options) 
  return axios.request(options) 

}

export function api_req_locid_edit(token, data) {

    console.log(token)
    console.log(data)
    //console.log(API_URL)
    const options = {
        method: 'POST',
        url: API_URL + "tg_location_id_req_data_edit",
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token
        },
        data: data
      };
   // console.log(options) 
    return axios.request(options) 

}

export function api_req_get_tags(chat_id, interval_days, token ) {

  console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'GET',
      url: API_URL + "tg_chat_id_tags_list",
      params: {chat_id: chat_id, interval_days: interval_days},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

}

export function api_req_get_qty_location_rows(chat_id, token, tags, str_search) {

  //console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'GET',
      url: API_URL + "tg_tag_and_str_search_count",
      params: {chat_id: chat_id, tags: tags, str_search: str_search},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

}

export function api_req_get_location_rows(chat_id, token, tags, str_search) {

  //console.log(token)
  //console.log(API_URL)
  const options = {
      method: 'GET',
      url: API_URL + "tg_tag_and_str_search",
      params: {chat_id: chat_id, tags: tags, str_search: str_search},
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': token
      },
      //data: {chat_id: chat_id}
    };
 // console.log(options) 
  return axios.request(options) 

} */

/* 
{
    "location_id": "20",
    "chat_id": "404529009",
		"gr_tags": "Hello",
		"url": "http://test1",
		"text": "Hello1 http://test1",
		"description": "description http://test1"
	
}
*/


/* POST
import axios from "axios";

const options = {
  method: 'POST',
  url: 'http://xtal.asia:4016/api/tg_post_test',
  headers: {
    'Content-Type': 'application/json',
    'User-Agent': 'insomnia/9.3.3',
    'x-access-token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiaWF0IjoxNzI2MDU2MjQwLCJleHAiOjE3MjYxNDI2NDB9.rR0xQ6ZGGfuq76cGquNHTgMfOM4Qut1G_B_XmSpKXDM'
  },
  data: {test1: 'mod', tes2: '123456'}
};

axios.request(options).then(function (response) {
  console.log(response.data);
}).catch(function (error) {
  console.error(error);
});

*/